<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      New Wait List
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card>
    <ion-card-header>
      <ion-button fill="clear" (click)="onClientNameTap(booking)"> 
        <b>{{ booking.client.firstName }} {{ booking.client.lastName }} </b>
      </ion-button>
    </ion-card-header>

    <ion-card-content>
      <ion-item *ngIf="booking">
        {{ booking.services.first().name }}
      </ion-item>
      <br/>
      <ion-item *ngIf="booking">
        Service Provider : {{ booking.services?.first().stylist?.firstName }} {{ booking.services?.first().stylist?.lastName }}
      </ion-item>
      <br/>


      <ion-item lines="none">
        <ion-label position="stacked">Notes</ion-label>
        <ion-textarea fill="outline" (ionChange)="onClientNotesChange($event)"></ion-textarea>
      </ion-item>
    </ion-card-content>
  </ion-card>
</ion-content>

<ion-footer class="ion-no-margin">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button expand="block" fill="outline" class="ion-no-margin" color="danger" [disabled]="savingInProgress" (click)="onBookingCancel()">
            <span>Cancel</span>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button expand="block" class="ion-no-margin" color="primary" (click)="onBookingSave()"> 
            <span *ngIf="!savingInProgress">Save</span>
            <ion-spinner name="crescent" *ngIf="savingInProgress"></ion-spinner>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
